export default {
	InvitationCode: "Pozývací Kód",
	CreditScore: "Kreditné Skóre",
	MyFinancial: {
		title: "Moje Finančné",
		menu: ["Vklad", "Výber", "Transakcia"]
	},
	MyDetail: {
		title: "Moje Detaily",
		menu: ["Osobné Informácie", "Platobné Metódy"]
	},
	Other: {
		title: "Iné",
		menu: ["Kontaktujte nás", "Oznámenia", "Zmeniť jazyk"]
	},
	Amount: ["Zostatok v Peňaženke", "Zmrazený Zostatok", "Dnešné Zárobky"],
	Logout: {
		title: "Odhlásiť sa",
		content: "Ste si istí, že sa chcete odhlásiť?"
	}
};
